import React from 'react';
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import useCountriesQuery from "./query";
import MDInput from "../../../materialDashboard/components/MDInput";


const CountryAutocomplete = ({MDInputProps={}, value, onChange, ...props}) => {
    const countries = useCountriesQuery();
    const selectedCountry = countries.data?.find(country => country.code === value);

    return (
        <Autocomplete
            fullWidth
            isOptionEqualToValue={(option, value) => {
                return option.code === value.code
            } }
            options={countries.data ?? []}
            autoHighlight
            getOptionLabel={(option) => option.name ?? ""}
            onChange={(event, newValue) => onChange(newValue?.code)}
            value={selectedCountry ?? null}
            loading={countries.isLoading}
            renderOption={(props, option) => {
                const { key, ...optionProps } = props;
                return (
                    <Box
                        key={key}
                        component="li"
                        sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                        {...optionProps}
                    >
                        <img
                            loading="lazy"
                            width="20"
                            srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                            src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                            alt=""
                        />
                        {option.name} ({option.code})
                    </Box>
                );
            }}
            renderInput={(params) => (
                <MDInput
                    {...params}
                    label="Choose a country"
                    inputProps={{
                        ...params.inputProps,
                        autoComplete: 'off', // disable autocomplete and autofill
                    }}
                    variant="standard"
                    {...MDInputProps}
                />
            )}
            {...props}
        />
    );
}

export default CountryAutocomplete;